var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateExpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.83333,
    stroke: "#8DCFF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_708_1603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6437 26.6667C13.1548 26.0444 11.1104 24.6 9.51035 22.3333C7.91035 20.0667 7.11035 17.5822 7.11035 14.88V8.53333L15.6437 5.33333L24.177 8.53333V14.88C24.177 17.5822 23.377 20.0667 21.777 22.3333C20.177 24.6 18.1326 26.0444 15.6437 26.6667ZM15.6437 25.0133C17.6881 24.3378 19.3548 23.0622 20.6437 21.1867C21.9326 19.3111 22.577 17.2089 22.577 14.88V9.65333L15.6437 7.04L8.71035 9.65333V14.88C8.71035 17.2089 9.3548 19.3111 10.6437 21.1867C11.9326 23.0622 13.5992 24.3378 15.6437 25.0133ZM15.6437 21.1467C17.0481 21.1467 18.257 20.64 19.2704 19.6267C20.2837 18.6133 20.7904 17.4044 20.7904 16C20.7904 14.5956 20.2837 13.3867 19.2704 12.3733C18.257 11.36 17.0481 10.8533 15.6437 10.8533C14.2392 10.8533 13.0304 11.36 12.017 12.3733C11.0037 13.3867 10.497 14.5956 10.497 16C10.497 17.4044 11.0037 18.6133 12.017 19.6267C13.0304 20.64 14.2392 21.1467 15.6437 21.1467ZM17.617 18.6933L14.977 16.2667V12.64H16.097V15.9467L18.337 17.9733L17.617 18.6933Z",
    fill: "#8DCFF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_708_1603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(5.33301 5.33333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateExpire);
export default __webpack_public_path__ + "static/media/certificate_expire.f38ffafcdf4bb4fef0d4122402147c02.svg";
export { ForwardRef as ReactComponent };